import "core-js/modules/web.dom.iterable";
//
//
//
//
import echarts from 'echarts';
import 'echarts/lib/chart/gauge';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
import moment from 'moment';
import { statisticsWarnNum } from '@/api/api';
export default {
  props: {
    width: {
      type: String,
      default: '450px'
    },
    height: {
      type: String,
      default: '280px'
    },
    top: {
      type: String,
      default: '18px'
    },
    left: {
      type: String,
      default: '0'
    },
    type: {}
  },
  data: function data() {
    return {
      chart: 'chart45'
    };
  },
  methods: {
    getWarnNum: function getWarnNum(st, category) {
      var that = this;
      var startTime = moment().subtract(7, 'days').format('YYYY-MM-DD');
      var endTime = moment().format('YYYY-MM-DD');
      statisticsWarnNum({
        st: st,
        category: category,
        stime: startTime,
        warnStatus: 1,
        etime: endTime
      }).then(function (res) {
        if (res.success) {
          var time = [];
          var lineData = [];
          res.result.forEach(function (item) {
            time.push(item.warnTimeStr);
            lineData.push({
              value: item.warnNum
            });
          });
          that.initBarChart(time, lineData);
        }
      });
    },
    initBarChart: function initBarChart(time, lineData) {
      var fontColor = '#30eee9';
      var option = {
        grid: {
          left: '5%',
          right: '10%',
          top: '10%',
          bottom: '20%',
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
            lineStyle: {
              color: '#57617B'
            }
          }
        },
        xAxis: [{
          type: 'category',
          boundaryGap: false,
          axisLabel: {
            color: '#65aaf1'
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#65aaf1',
              width: 1
            }
          },

          /*axisTick:{
                  show:false,
              },
              splitLine:{
                  show:true,
                  lineStyle:{
                      color:'#195384'
                  }
              },*/
          data: time
        }],
        yAxis: [{
          type: 'value',
          axisLabel: {
            color: '#65aaf1' //刻度线标签颜色

          },
          splitLine: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#65aaf1'
            }
          }
        }],
        series: [{
          name: '七日预警统计',
          type: 'line',
          symbol: 'circle',
          showSymbol: false,
          symbolSize: 8,
          itemStyle: {
            normal: {
              areaStyle: {
                //color: '#94C9EC'
                color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                  offset: 0.2,
                  color: 'rgba(80,0,90,0.1)'
                }, {
                  offset: 1,
                  color: 'rgba(150,0,246,0.9)'
                }])
              }
            }
          },
          data: lineData
        }]
      };
      var chart = this.$refs[this.chart];
      var myChart = this.$echarts.init(chart);
      myChart.setOption(option);
      window.addEventListener('resize', function () {
        myChart.resize();
      });
    }
  },
  watch: {
    type: {
      handler: function handler(val) {
        this.getWarnNum('52', val);
      },
      immediate: true
    }
  }
};